/**
 * @tabler/icons-react v2.25.0 - MIT
 */
import createReactComponent from '../createReactComponent.js';
var IconChevronsDown = createReactComponent("chevrons-down", "IconChevronsDown", [["path", {
  d: "M7 7l5 5l5 -5",
  key: "svg-0"
}], ["path", {
  d: "M7 13l5 5l5 -5",
  key: "svg-1"
}]]);
export { IconChevronsDown as default };